<template>
    <div class="table-wrp">
        <b-table striped bordered no-local-sorting
                 :busy="isBusy"
                 :items="items"
                 :fields="fields"
                 :per-page="0"
                 :sort-by.sync="sortBy"
                 :sort-desc="sortDir === 'desc'"
                 :key="selected.length"
                 @head-clicked="headClicked">
            <template #head(id-check)>
                <b-form-checkbox v-model="selectAll" :indeterminate.sync="hasSelectionExceptions" id="selection-popover-target" />

                <b-popover target="selection-popover-target" triggers="focus" :show="selectAll">
                    <template #title>Selectie</template>
                    <b-form-group>
                        <b-form-radio v-model="hasSelectionExceptions" :value="false">
                            Selecteer alle resultaten
                        </b-form-radio>
                        <b-form-radio v-model="hasSelectionExceptions" :value="true">
                            Selecteer alleen getoonde resultaten
                        </b-form-radio>
                    </b-form-group>
                </b-popover>
            </template>

            <template #cell(id-check)="row">
                <b-form-checkbox v-model="selected" :value="row.item.id" />
            </template>
            <template #cell(actions)="row">
                <div v-if="!row.item.trashed">
                    <b-button
                        v-if="showRoute"
                        variant="primary"
                        class="mr-2"
                        size="sm"
                        @click="$router.push({ name: showRoute, params: { id: row.item.id } })">
                        Bekijk
                    </b-button>
                    <b-button
                        variant="danger"
                        size="sm"
                        @click="openDeleteModal(row.item)"
                        v-if="row.item.links.destroy && !row.item.trashed">
                        Verwijder
                    </b-button>
                </div>
                <b-button
                    v-else-if="row.item.links.restore"
                    variant="secondary"
                    size="sm"
                    @click="restoreItem(row.item.links.restore)">
                    Herstel
                </b-button>
            </template>

            <template v-for="field in customFields" v-slot:[normalizedCellName(field)]="row">
                <component :is="field.field" :meta="field.meta" v-model="row" :key="'row-' + row.item.id + '-column-' + field.key"/>
            </template>
        </b-table>
        <b-row>
            <b-col>
                <b-pagination v-if="totalItems" size="md" v-model="currentPageNumber" :total-rows="totalItems" :per-page="currentPerPage" :disabled="isBusy"></b-pagination>
            </b-col>
            <b-col class="text-right align-middle">
                <i>{{ currentPerPage }} van de {{ totalItems }} items in totaal</i>
            </b-col>
        </b-row>
        <b-modal centered id="delete-object" ref="delete-object" title="Verwijder object">
            <p class="my-4">
                Weet je zeker dat je het object <strong>"{{deletable.resource_name}}"</strong> wilt verwijderen?
                <span v-if="deletable.links && deletable.links.restore === null">Deze actie is onomkeerbaar.</span>
            </p>
            <template #modal-footer>
                <b-button @click="hideDeleteModal">Nee</b-button>
                <b-button variant="danger" @click="deleteItem">Ja, verwijder</b-button>
            </template>
        </b-modal>

      <b-spinner label="Loading..." v-if="isBusy"></b-spinner>
    </div>
</template>

<script>
  import {deleteItem, getData, updateData} from "../api";

    let timer = null;

    export default {
        props: {value: {}, endpoint: {}, showRoute: null},

        data() {
            return {
                isBusy: false,
                items: [],
                fields: [],
                filters: [],
                actions: [],
                sortBy: undefined,
                sortDir: undefined,
                totalItems: undefined,
                currentPage: 1,
                perPage: undefined,
                deletable: [],
                selected: [],
                selectAll: false,
                hasSelectionExceptions: null,
            };
        },
        computed: {
            customFields(){
                return this.fields.filter(filter => filter.field !== 'field-text' && filter.key !== 'actions' && filter.key !== 'id-check');
            },
            currentPerPage: {
              get: function () {
                return this.perPage > this.totalItems ? this.totalItems : this.perPage;
              },
              set: function(value) {
                this.perPage = value;
              }
            },
            currentPageNumber: {
              get: function () {
                return this.currentPage;
              },
              set: function (value) {
                this.currentPage = value;
              }
            }
        },
        methods: {
            normalizedCellName(field){
                return `cell(${field.key})`;
            },

            async getItems() {
              this.isBusy = true;

              return await this.call().then(async response => {
                this.filters = response.filters;
                this.actions = response.actions;
                this.items = response.data;
                this.fields = response.fields;
                this.perPage = response.per_page;
                this.totalItems = response.total;
                this.currentPage = response.current_page;
                this.sortBy = response.sort_by;
                this.sortDir = response.sort_direction;

                this.syncData();
                await this.storeTableSettings({currentPage: this.currentPage});

                this.isBusy = false;

              }).catch(error => {
                console.log('Error: ', error);
                throw error;
              });
            },

            syncData() {
                this.$emit('input', this.filters);
                this.$emit('inputActions', this.actions);
            },

            async call() {
                let params = {
                    page: this.currentPage || 1
                };

                if (this.sortBy) {
                    params.sort_by = this.sortBy;
                    params.sort_direction = this.sortDir || 'asc';
                }

                this.value
                    .filter(item => (typeof item.value !== 'undefined' && item.value !== undefined))
                    .forEach(item => {
                        params[item.name] = item.value;
                    });

                const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');

                return await getData(`${this.endpoint}?${queryString}`)
                    .then(response => response.data);
            },

            openDeleteModal(item) {
                this.deletable = item;
                this.$refs['delete-object'].show()
            },
            hideDeleteModal() {
                this.$refs['delete-object'].hide();
            },
            async deleteItem() {
                this.isBusy = true;
                this.hideDeleteModal();
                await deleteItem(this.deletable.links.destroy, true);
                await this.getItems();
                this.isBusy = false;
            },
            async restoreItem(restoreLink) {
                this.isBusy = true;
                await updateData(restoreLink, [], true);
                await this.getItems();
                this.isBusy = false;
            },
            headClicked: function (key, field) {
                if(field.sortable === false){
                    return;
                }

                this.sortBy = key;
                this.sortDir = field.sort === 'asc' ? 'desc' : 'asc';
                this.getItems();
            },
            storeTableSettings(value) {
                const result = new Promise((resolve, reject) => {
                  const namespace = this.endpoint;

                  localStorage.setItem(`${namespace}-settings`, JSON.stringify(value));

                  resolve();
                });

                return result;
            },
            autoLoadTableSettings() {
                const result = new Promise((resolve, reject) => {
                  const namespace = this.endpoint;

                  const settings = localStorage.getItem(`${namespace}-settings`);

                  if (settings) {
                      const parsed = JSON.parse(settings);

                      if (parsed && parsed.currentPage) {
                        this.currentPage = parsed.currentPage;
                      }
                  }
                  resolve();
                });

                return result;
            },
        },
        beforeMount() {
            this.autoLoadTableSettings().then(async () => {
              await this.getItems();
            });
        },
        watch: {
            selectAll: function(value) {
                if (!value) {
                    this.hasSelectionExceptions = null;
                    this.selected = [];
                }
            },
            selected: function(value){
                let selection = this.selected;

                if (this.hasSelectionExceptions === false && value.length !== 0 && value.length !== this.items.length){
                    this.hasSelectionExceptions = true;
                } else if (this.hasSelectionExceptions === false && value.length !== 0) {
                    selection = 'all';
                } else {
                    selection = [];
                }

                this.$emit('select', selection);
            },
            hasSelectionExceptions(value){
                if(value === false) {
                    this.selected = this.items.map(x => x.resource_key);
                } else {
                    this.$emit('select', this.selected);
                }
            },
            currentPage: {
                handler: function (value) {
                    if (timer) clearTimeout(timer);
                    if (!this.isBusy) {
                      timer = setTimeout(() => {
                          this.getItems();
                      }, 500);
                    }
                }
            },

            value: {
                deep: true,
                handler: function (value) {
                    if (timer) clearTimeout(timer);
                    if (!this.isBusy) {
                      timer = setTimeout(() => {
                          this.currentPage = 1;
                          this.getItems();
                      }, 500);
                    }
                }
            }
        }
    }
</script>
